// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.route-label-2-enter-active,\n.route-label-leave-active {\n  transition: opacity 0.15s;\n}\n.route-label-2-enter,\n.route-label-2-leave-to {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
